import { Box, Image, Spinner } from '@chakra-ui/react';

import { UploadIcon } from 'Asset/icon';
import { Condition } from 'Component/others';

import styles from './styles.module.css';

const ImageUploadBox = ({ imagePreview, fileInputRef, onImageChange, isUploading }) => (
  <Box className={styles['product-create__image']} onClick={() => !isUploading && fileInputRef.current.click()}>
    <Condition
      statement={isUploading}
      fallback={
        <Condition
          statement={imagePreview}
          fallback={<UploadIcon width="24px" height="24px" color="var(--color-neutral50)" />}
        >
          <Image src={imagePreview} width="100%" height="100%" objectFit="cover" borderRadius="var(--radius-sm)" />
        </Condition>
      }
    >
      <Spinner size="sm" color="var(--color-neutral50)" />
    </Condition>
    <input
      ref={fileInputRef}
      type="file"
      accept="image/*"
      style={{ display: 'none' }}
      onChange={onImageChange}
      disabled={isUploading}
    />
  </Box>
);

export default ImageUploadBox;
